import { BrowserRouter, Route, Routes } from "react-router-dom"
import Footer from "./components/Footer"
import Confirm from "./nav/Confirm"
import Contact from "./nav/Contact"
import Error from "./nav/Error"
import FAQ from "./nav/FAQ"
import Home from "./nav/Home"
import Terms from "./nav/Terms"
import Store from "./store/store"
import PromoSoon from "./nav/PromoSoon"
import PromoOver from "./nav/PromoOver"

declare global {
	interface Window {
		Cookiebot: any
	}
}
const App = () => {
	//  Sun Apr 16 2023 00:00:00 UTC+0200 (Mitteleuropäische Sommerzeit)   https://time.is/de/Unix_time_converter
	let isPromoOver = parseInt(Math.floor(Date.now() / 1000).toString()) > 1756677599
	return (
		<BrowserRouter basename={`${process.env.PUBLIC_URL}`}>
			<Store>
				<main className="mx-auto w-full">
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/danke" element={<Confirm />} />

						<Route path="/promoover" element={<PromoOver />} />
						<Route path="/promosoon" element={<PromoSoon />} />

						<Route path="/faq" element={<FAQ />} />
						<Route path="/teilnahmebedingungen" element={<Terms />} /> 
						<Route path="/kontakt" element={<Contact />} /> 
						<Route path="/:err" element={<Error />} />
					</Routes>
					<Footer />
				</main>
			</Store>
		</BrowserRouter>
	)
}

export default App
